import ImageListTileUI from '@gogame/ui/ImageListItem';
import { makeStyles } from '@gogame/ui/styles';

import withHoverScaleImg from './withHoverScaleImg';

const useStyles = makeStyles((theme) => ({
  content: {
    cursor: 'pointer',
    background: theme.palette.text.action,
    height: '100%',
    userSelect: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
}));

export const ImageListItem = withHoverScaleImg(({ children, ...props }) => {
  const classes = useStyles();

  return (
    <ImageListTileUI {...props}>
      <div className={classes.content}>{children}</div>
    </ImageListTileUI>
  );
});
